import { t } from 'i18next'
import React from 'react'
import { CandidateFormValues } from '../../store/types/form/CandidateFormValues'
import { Control } from 'react-hook-form'
import { Typography } from '@mui/material'
import AutocompleteInput from '../../components/Form/Inputs/AutocompleteInput'
import { useGetUsersQuery } from '../../store/redux/reducers/usersSlice'
import RoleType from '../../store/types/enums/RoleType'
import TextInput from '../../components/Form/Inputs/TextInput'

type CandidateDetailsInputsProps = {
  control: Control<CandidateFormValues>
}

const CandidateDetailsFirstRecruitmentInputs = ({
  control,
}: CandidateDetailsInputsProps) => {
  const { data: managementAndRecruiters } = useGetUsersQuery({
    page: 0,
    size: 20,
    'roles.name': [RoleType.Management, RoleType.Recruiter].toString(),
  })

  return (
    <>
      <Typography variant="h5" color="text.highEmphasis">
        {t('page.candidateDetails.firstRecruitmentStageInformation')}
      </Typography>
      <AutocompleteInput
        options={
          managementAndRecruiters
            ? managementAndRecruiters.content.map(user => ({
                value: user.id.toString(),
                label: `${user.firstName} ${user.lastName}`,
              }))
            : []
        }
        multiple
        disableCloseOnSelect
        name={'responsibles'}
        control={control}
        label={t('page.candidateDetails.tiles.responsibles')}
      />
      <TextInput
        name={'comment'}
        control={control}
        label={t('page.candidateDetails.tiles.comment')}
        maxLength={500}
        rules={{
          maxLength: { value: 500, message: t('page.worklog.form.descriptionLengthError') },
        }}
        multiline
        rows={8}
        showCharCounter
      />
    </>
  )
}

export default CandidateDetailsFirstRecruitmentInputs